import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageDelivery2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-delivery-2, address"><path d="M13.25 20.25H3.75V3.75H8.75M8.75 3.75H15.25M8.75 3.75V9.25H15.25V3.75M15.25 3.75H20.25V10.25M18.25 20.5L16.1287 18.3765C14.9571 17.2038 14.9571 15.3023 16.1287 14.1296C17.3003 12.9568 19.1997 12.9568 20.3713 14.1296C21.5429 15.3023 21.5429 17.2038 20.3713 18.3765L18.25 20.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageDelivery2;
